// import axios from "axios";
import Properties from "../properties";
import apiClient from "../plugins/axios-instance";

const API_URL_DEVELOPMENT = "https://api.amigogroup.id/poin-vouchers/rekap-history-vouchers";
const API_URL_PRODUCTION = "https://backend.amigogroup.net/poin-voucher/api/rekap-history-vouchers";


export default class LaporanTukarServices {
  constructor() {}
  config = this.$session.get("jwt");

  static getURL = () => {
    return Properties.BUILD_TYPE == "production" ? API_URL_PRODUCTION : API_URL_DEVELOPMENT;
  }

  static getLaporan = (body) => {
    return apiClient.get(
      this.getURL() + "",
      {
        params: body,
      }
    );
  }
}
